module.exports = __webpack_public_path__ + "img/logo-UMUC.36e29299.svg";